module.exports = {"modalTitle":"Select one or more regions","title":"Season tickets","intro":"For which region(s) do you want to view season tickets?","selectRegions":"Select region(s)","changeRegionSelection":"Change region(s)","buttonText":"View season tickets"}


//////////////////
// WEBPACK FOOTER
// ./src/locale/en/region-select.json
// module id = HD3x
// module chunks = 1